import { useCurrentInstance } from '@/api/organization';
import { InstanceNavigate } from '@/components/routing';
import { FEATURE_FLAG } from '@/constants/featureFlags';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

import { ROUTES } from './routes';
import { DEFAULT_APP_PATH, DEFAULT_ONBOARDING_PATH } from './routes';

const DefaultAppRedirect = () => {
  const { instance, isLoading, error } = useCurrentInstance();
  const hasAIVisibility = !!useFeatureFlag(FEATURE_FLAG.aiVisibility);
  if (isLoading || error || !instance) return null;
  if (!instance.tagInstallationDate && instance.firstAIVisibilityRunDate && hasAIVisibility) {
    return <InstanceNavigate to={ROUTES.aiVisibilityOverview.path} replace />;
  }

  if (!instance?.tagInstallationDate) {
    return <InstanceNavigate to={DEFAULT_ONBOARDING_PATH} replace />;
  }

  return <InstanceNavigate to={DEFAULT_APP_PATH} replace />;
};

export default DefaultAppRedirect;
